import { CheckboxProps } from 'syf-component-library/typings/checkbox'
import { Checkbox as CheckboxCL } from 'syf-component-library/ui/atoms'
import { PropsWithRequiredChildren } from 'syf-component-library/typings/utils'
import styled from 'styled-components'

/*
 * Override align-items applied by v1.27.2 of CL which broke layout in many
 * places for checkbox labels.
 */
const Checkbox = styled(
  ({ children, ...props }: PropsWithRequiredChildren<CheckboxProps>) => (
    <CheckboxCL {...props}>{children}</CheckboxCL>
  )
)`
  & > label {
    align-items: center;
  }
`

export default Checkbox
